<template>
  <placeholders-form :data="placeholder"
                     :title="$t('searchSuggestions.edit.title', { name: placeholder ? placeholder.name : ''})"
                     :submit-loading="submitLoading"
                     @submit="onSubmit">
  </placeholders-form>
</template>
<script>
  import PlaceholdersForm from './PlaceholdersForm'
  import LanguageSelect from 'src/components/LanguageSelect'
  import PlaceholdersService from 'src/services/PlaceholdersService'

  export default {
    components: {
      LanguageSelect,
      PlaceholdersForm,
    },
    data () {
      return {
        submitLoading: false,
        placeholder: null,
      }
    },
    methods: {
      async getData () {
        let {data} = await PlaceholdersService.getById(this.$route.params.id)
        this.placeholder = data
      },
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await PlaceholdersService.update(data.id, data)
          this.$router.go(-1)
        } finally {
          this.submitLoading = false
        }
      },
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.getData()
      },
    },
    async created () {
      await this.getData()
    }
  }
</script>
<style>
</style>
